import { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants';
import { DeleteIcon } from '../../icons';
import { CoreIconButton, CoreTooltip } from '../_core';
import { clsx } from '../../utils';

export interface CardDeleteButtonProps {
	sx?: SxProps<Theme>;
	wrapperSx?: SxProps<Theme>;
	tooltip?: string;
	disabled?: boolean;
	onDelete(): void;
}

export const CardDeleteButton: FC<CardDeleteButtonProps> = (props) => {
	const { sx, disabled, tooltip, wrapperSx, onDelete } = props;

	return (
		<CoreTooltip
			arrow
			dark
			title={disabled ? tooltip : undefined}
			placement='top'
		>
			<Box
				component='span'
				sx={clsx(
					{
						position: 'absolute',
						top: '-11px',
						right: '-7px',
						zIndex: 1,
					},
					wrapperSx,
				)}
			>
				<CoreIconButton
					onClick={onDelete}
					disabled={disabled}
					sx={clsx(
						{
							p: '5px',
							backgroundColor: Colors['2A2A2A'],
							borderRadius: '50%',
							border: `1px solid ${Colors.white_a10}`,
							color: Colors.white,
						},
						sx
					)}
				>
					<Box
						component={DeleteIcon}
						width={20}
						height={20}
					/>
				</CoreIconButton>
			</Box>
		</CoreTooltip>
	);
}
